export default __webpack_public_path__ + "pl-extra.38fd67a6c26e58f5c912568332c7c074.json";